import { generateThemeOverride } from '@botpress/webchat'
import { LatestWebchatTheme } from '@bpinternal/shared'
import { ReactNode, useMemo } from 'react'
import { cn } from '~/utils'

type WebchatComponentPreviewProps = {
  theme?: LatestWebchatTheme
  children: ReactNode
  className?: string
}

const BASE_THEME_VARIABLES = {
  '--bpFontSize-scale': '1',
  '--bpFontSize-xs': '12px',
  '--bpFontSize-sm': '14px',
  '--bpFontSize-base': '16px',
  '--bpFontSize-md': '18px',
  '--bpFontSize-lg': '20px',
  '--bpFontSize-xl': '22px',
  '--bpFontSize-2xl': '24px',
  '--bpFontSize-3xl': '30px',
  '--bpFontSize-4xl': '36px',
  '--bpRadius-scale': '1',
  '--bpRadius-sm': '2px',
  '--bpRadius-md': '6px',
  '--bpRadius-lg': '8px',
  '--bpRadius-xl': '12px',
  '--bpRadius-2xl': '16px',
  '--bpRadius-3xl': '24px',
  '--bpRadius-full': '9999px',
  '--bpSpacing-0': '0px',
  '--bpSpacing-px': '1px',
  '--bpSpacing-0_5': '2px',
  '--bpSpacing-1': '4px',
  '--bpSpacing-1_5': '6px',
  '--bpSpacing-2': '8px',
  '--bpSpacing-2_5': '10px',
  '--bpSpacing-3': '12px',
  '--bpSpacing-3_5': '14px',
  '--bpSpacing-4': '16px',
  '--bpSpacing-4_5': '18px',
  '--bpSpacing-5': '20px',
  '--bpSpacing-6': '24px',
  '--bpSpacing-7': '28px',
  '--bpSpacing-8': '32px',
  '--bpSpacing-9': '36px',
  '--bpSpacing-10': '40px',
  '--bpSpacing-11': '44px',
  '--bpSpacing-12': '48px',
  '--bpSpacing-14': '56px',
  '--bpSpacing-16': '64px',
  '--bpSpacing-20': '80px',
  '--bpSpacing-24': '96px',
  '--bpSpacing-28': '112px',
  '--bpSpacing-32': '128px',
  '--bpSpacing-36': '144px',
  '--bpSpacing-40': '160px',
  '--bpSpacing-44': '176px',
  '--bpSpacing-48': '192px',
  '--bpSpacing-52': '208px',
  '--bpSpacing-56': '224px',
  '--bpSpacing-60': '240px',
  '--bpSpacing-64': '256px',
  '--bpSpacing-72': '288px',
  '--bpSpacing-80': '320px',
  '--bpSpacing-96': '384px',
} as const

export const WebchatComponentPreview: React.FC<WebchatComponentPreviewProps> = ({
  theme,
  children,
  className,
}: WebchatComponentPreviewProps) => {
  const styleOverride = useMemo(() => {
    const themeOverride = generateThemeOverride({ ...theme })
    return {
      ...BASE_THEME_VARIABLES,
      ...themeOverride,
    } as React.CSSProperties
  }, [theme])

  return (
    <div className={cn('w-full overflow-clip', className)} style={styleOverride}>
      {children}
    </div>
  )
}

export default WebchatComponentPreview
